import { DecimalCounterInput } from './decimal-counter-input';
import type { DecimalCounterInputProps } from './use-decimal-counter-input';

import { FormControl, FormItem, FormMessage } from '../../form';

export const FormDecimalCounter = ({
  formItemClassName,
  hideMsg,
  ...props
}: DecimalCounterInputProps & { formItemClassName?: string; hideMsg?: boolean }) => (
  <FormItem className={formItemClassName}>
    <FormControl>
      <DecimalCounterInput {...props} />
    </FormControl>
    {!hideMsg && <FormMessage />}
  </FormItem>
);
